import moment, { Moment } from 'moment-timezone';

export const mcDate = {
  /** YYYY-MM-DD */
  shortDateNow() {
    return moment().format('YYYY-MM-DD');
  },

  /**
   * YYYY-MM-DD
   * @param value
   */
  toShortDate(value) {
    return moment(value).format('YYYY-MM-DD');
  },

  /**
   * Convert UTC to local moment
   * @param value
   */
  utcToLocal(value) {
    return moment.utc(value).local();
  },

  /**
   * Get user local time
   * @param value 
   */
  toDateTime(value: moment.Moment) {
    return value.format('MM/DD/YYYY h:mm:ss A');
  },

  toTime(value: moment.Moment) {
    return value.format('h:mm:ss A');
  },

  /** moment.defaultFormatUtc: YYYY-MM-DDTHH:mm:ss[Z] */
  utcNow() {
    return moment().format(moment.defaultFormatUtc);
  },

  /**
   * moment.defaultFormatUtc: YYYY-MM-DDTHH:mm:ss[Z]
   * @param value
   */
  toUtc(value) {
    return moment(value).format(moment.defaultFormatUtc);
  },

  /**
   * YYYY-MM-DDTHH:mm:ss.SSS
   * @param value
   */
  toUtcMillis(value) {
    // moment.defaultFormatUtc doesn't include millis.
    return moment.utc(value).format('YYYY-MM-DDTHH:mm:ss.SSS');
  },

  /**
   * Determine if leftDate is after or equal to rightDate. moment.isBefore(someDate) returns unexpected results
   * @param {moment.Moment} leftDate moment date to compare and see if it is after rightDate
   * @param {moment.Moment} rightDate moment date to compare and see if it is after leftDate
   * @returns {(number|null)} -1 if leftDate is before rightDate, 1 if leftDate is after rightDate, 0 if they are the same time, null if the dates are not valid
   */
  isAfter(leftDate: moment.Moment, rightDate: moment.Moment): (number | null) {
    if (leftDate.isValid && rightDate.isValid) {
      if (leftDate < rightDate) {
        // Before
        return -1;
      }
      else if (leftDate > rightDate) {
        // After
        return 1;
      }
      else {
        // Same
        return 0;
      }
    }

    console.warn('The dates supplied are invalid!');
    return null;
  },
  offset(){
    return moment().utcOffset() * -1;
  },
  timeZone(){
    return moment().tz(moment.tz.guess()).format('z');
  },
  isToday(value: moment.Moment){
    const today = moment(0, "HH");
    return today.diff(value, "days") == 0;
  }
}
